module.exports = __webpack_public_path__ + "c_static/img/1-5查看评价.86a1123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/1-5查看评价.jpg
// module id = B/t6
// module chunks = 33